// extracted by mini-css-extract-plugin
export default {"content":"reopen-chat-dialog_content__MNNJo","tip":"reopen-chat-dialog_tip__uFKMf"};